import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { Button } from "antd";

import { useAppLayoutSidebarCollapsed } from "@/modules/app-layout/app-layout-sidebar";

export const AppLayoutSidebarTrigger = () => {
  const { collapsed, setCollapsed } = useAppLayoutSidebarCollapsed();

  return (
    <Button
      type="text"
      icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
      onClick={() => setCollapsed(!collapsed)}
    />
  );
};
